import { ListSectionProps } from "../../types/sectionTypes";

export const emptySection: ListSectionProps = {
  sectionID: "",
  sectionName: "",
  file: "",
  fileName: "",
  fileToken: "",
  status: "",
  projectID: "",
  createdTime: 0,
  updatedTime: 0,
  revision:0,
  kks: "",
};
